import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'react-aria-components';
import { selectImageBase64 } from '@store/order/selectors';
import { setImageBase64 } from '@store/order/slice';
import ImageInput from '@pages/order/animal-info/upload-images/ImageInput';



export const UploadImages = () => {
	const { t } = useTranslation('forms');

	const imageBase64 = useSelector(selectImageBase64);
	const dispatch = useDispatch();
	const deleteImageBase64 = () => dispatch(setImageBase64(null));

	return (
		<div className='upload-images-section'>
			
			<p>{t('animalInfo.uploadImages.text')}</p>

			<ImageInput />

			<div className='uploaded-images'>
				{imageBase64 &&
					<div className='uploaded-image-background'>
						<img src={imageBase64} alt='pattern-item' draggable={false} />

						<Button
							className='uploaded-image-delete'
							onPress={() => deleteImageBase64()}>
							&#10006;
						</Button>
					</div>
				}
			</div>
		
		</div>
	)
}

export default UploadImages;